import { useEffect } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Layout from '../components/layout/Layout'

function AuthCallbackPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const error = searchParams.get('error')

  useEffect(() => {
    if (!error) {
      navigate('/auth?mode=sign-in', { replace: true })
    }
  }, [error, navigate])

  if (error) {
    return (
      <Layout>
        <div className='registration'>
          <div className='registration-error'>
            <h1>{t('auth.error')}</h1>
            <p>{error}</p>
            <p>
              {t('auth.contactSupport')} <a href='mailto:contact@cloudsoft.com.pl'>{t('auth.contactSupportLink')}</a>.
            </p>
            <p>
              <Link to='/auth?mode=sign-in'>{t('auth.backToSignIn')}</Link>
            </p>
          </div>
        </div>
      </Layout>
    )
  }

  return (
    <Layout>
      <div className='registration'>
        <div className='registration-success'>
          <h1>{t('auth.redirecting')}</h1>
          <p>{t('auth.callbackRedirectMessage')}</p>
        </div>
      </div>
    </Layout>
  )
}

export default AuthCallbackPage
